/** L'état d'une commande, dit au client. */
export const ETATS_COMMANDE = {
  RECUE: { texte: 'Envoyée — le magasin va la confirmer', couleur: '#B45309' },
  A_PREPARER: { texte: 'Acceptée par le magasin', couleur: '#0F6B3A' },
  EN_PREPARATION: { texte: 'En préparation', couleur: '#0369A1' },
  PRETE: { texte: 'Prête à retirer / à livrer', couleur: '#0F6B3A' },
  LIVREE: { texte: 'Livrée', couleur: '#475569' },
  ANNULEE: { texte: 'Annulée', couleur: '#B91C1C' },
};
